module.exports = __webpack_public_path__ + "static/media/plantA.07464b28.png";